module.exports = __webpack_public_path__ + "img/copy.745449c2.svg";